module.exports = __webpack_public_path__ + "static/img/statistics_icon_blue.b7f5773.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/statistics_icon_blue.png
// module id = l6g0
// module chunks = 1